(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["high-dreams-benefits"] && !Shopify.designMode) return;
  try {
    
(() => {
 const selector='[data-hd-benefits]';
 const observers=new WeakMap();
 const initialise=(section)=>{
  if(section.dataset.initialised==='true') return;
  section.dataset.initialised='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches && section.dataset.preview!=='true';
  const reveal=Array.from(section.querySelectorAll('[data-hdb-reveal]'));
  if(section.dataset.animate==='true' && !reduced && 'IntersectionObserver' in window){
   section.dataset.ready='true';
   const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting) return;
    entry.target.classList.add('is-shown');
    observer.unobserve(entry.target);
   }),{threshold:0.12});
   observers.set(section,observer);
   const mobile=window.matchMedia('(max-width:600px)').matches;
   const stagger=Number(section.dataset.stagger)||0;
   reveal.forEach((item,index)=>{
    item.style.transitionDelay=(mobile?0:Math.min(index*stagger,400))+'ms';
    item.addEventListener('transitionend',event=>{
     if(event.target===item && event.propertyName==='opacity') item.style.transitionDelay='0ms';
    });
   });
   requestAnimationFrame(()=>requestAnimationFrame(()=>{
    if(section.isConnected) reveal.forEach(item=>observer.observe(item));
   }));
  } else reveal.forEach(item=>item.classList.add('is-shown'));
  const controls=new Map();
  section.querySelectorAll('.hdb-question').forEach(details=>{
   const summary=details.querySelector('summary');
   let animation=null;
   let wanted=details.open;
   const setOpen=next=>{
    if(wanted===next && (animation || details.open===next)) return;
    wanted=next;
    if(reduced || typeof details.animate!=='function') {details.open=next; return;}
    const start=details.getBoundingClientRect().height;
    if(animation) {animation.onfinish=null; animation.cancel();}
    details.style.height=start+'px';
    details.style.overflow='hidden';
    let end;
    if(next){
     details.open=true;
     details.style.height='auto';
     end=details.getBoundingClientRect().height;
     details.style.height=start+'px';
    } else end=summary.getBoundingClientRect().height+2;
    animation=details.animate({height:[start+'px',end+'px']},{duration:350,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
    animation.onfinish=()=>{
     details.open=wanted;
     details.style.height='';
     details.style.overflow='';
     animation.cancel();
     animation=null;
    };
   };
   controls.set(details,setOpen);
   summary.addEventListener('click',event=>{
    if(reduced || typeof details.animate!=='function') return;
    event.preventDefault();
    setOpen(!wanted);
   });
   details.addEventListener('toggle',()=>{
    if(reduced || !animation) wanted=details.open;
    if(details.open && section.dataset.single==='true') controls.forEach((change,other)=>{
     if(other!==details && other.open) change(false);
    });
   });
  });
 };
 const within=scope=>{
  if(scope.matches && scope.matches(selector)) initialise(scope);
  scope.querySelectorAll(selector).forEach(initialise);
 };
 within(document);
 document.addEventListener('shopify:section:load',event=>within(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll(selector).forEach(section=>{
  const observer=observers.get(section); if(observer) observer.disconnect();
 }));
 document.addEventListener('shopify:block:select',event=>{
  const block=event.target.closest('.hdb-card,.hdb-question'); if(!block) return;
  const reveal=block.closest('[data-hdb-reveal]'); if(reveal) reveal.classList.add('is-shown');
  if(block.matches('details')) block.open=true;
 });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["high-dreams-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-hd-collection-cards]';
  const observers = new WeakMap();
  const initialiseSection = (section) => {
    if (!section || section.dataset.hdInitialised === 'true') return;
    section.dataset.hdInitialised = 'true';
    const cards = Array.from(section.querySelectorAll('[data-hd-card]'));
    if ((window.matchMedia('(prefers-reduced-motion: reduce)').matches && section.dataset.hdPreview !== 'true') || section.dataset.hdEffect === 'none' || !('IntersectionObserver' in window)) {
      cards.forEach((card) => card.classList.add('is-visible'));
      return;
    }
    const mobile = window.matchMedia('(max-width: 600px)').matches;
    const stagger = Number(section.dataset.hdStagger) || 0;
    const repeat = section.dataset.hdRepeat === 'true';
    section.dataset.hdReady = 'true';
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const card = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.12) {
          card.style.transitionDelay = mobile ? '0ms' : Math.min(cards.indexOf(card) * stagger, 600) + 'ms';
          card.classList.add('is-visible');
          if (!repeat) observer.unobserve(card);
        } else if (!entry.isIntersecting && repeat) {
          card.style.transitionDelay = '0ms';
          card.classList.remove('is-visible');
        }
      });
    }, { threshold: [0, 0.12] });
    observers.set(section, observer);
    cards.forEach((card) => card.addEventListener('transitionend', (event) => {
      if (event.target === card && event.propertyName === 'opacity' && card.classList.contains('is-visible')) card.style.transitionDelay = '0ms';
    }));
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (section.isConnected) cards.forEach((card) => observer.observe(card));
    }));
  };
  const initialiseWithin = (scope) => {
    if (scope.matches && scope.matches(selector)) initialiseSection(scope);
    scope.querySelectorAll(selector).forEach(initialiseSection);
  };
  initialiseWithin(document);
  document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((section) => {
      const observer = observers.get(section);
      if (observer) observer.disconnect();
    });
  });
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-hd-card]');
    if (card) {card.style.transitionDelay = '0ms'; card.classList.add('is-visible');}
  });
})();

  } catch(e) { console.error(e); }
})();
})();
